import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

const Support = (props) => {
    const { content } = props;

    const [ finalList, setFinalList ] = useState([]);

    useEffect(() => {
        const list = content;
        const extra = list.length % 4 === 0 ? 0 : 4 - list.length % 4;

        for (let i = 0; i < extra; i++) {
            list.push({ isEmpty: true });
        }
        setFinalList(list);
    }, [content]);

    return (
        <div className={styles.support}>
            {
                finalList.map((item, index) => {
                    return (
                        <div key={index}>
                            {
                                !item.isEmpty &&
                                <a href={item.url} target="_blank" rel="noreferrer">
                                    <img src={formatImage(item.image, 244 * 2, 114 * 2)} alt="" />
                                </a>
                            }
                        </div>
                    );
                })
            }
        </div>
    );
};

Support.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(Support);
